<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pa-3">
        <lista-precios-venta-crud />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListaPreciosVentaCrud from "./ListaPreciosVentaCrud";

export default {
  name: "ListaPreciosVenta",
  components: { ListaPreciosVentaCrud },
};
</script>
